export const skeletonTheme = {
  root: {
    borderRadius: 'var(--border-radius)',
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--p-surface-300)',
      },
    },
    dark: {
      root: {
        background: 'var(--p-surface-700)',
      },
    },
  },
};
